import { ref, reactive } from 'vue';

import Api from '@/api/Api';
import Utils from '@/api/Utils';

export function useFormSettings(formState) {
	// запрашивает настройки формы, которые не зависят от выбора БС
	const isLoadingSettings = ref(true);
	const formSettings = reactive({
		protocols: [],
		subNetworks: [],
		antReferencePoints: [],
		supportedAntennas: [],
		storagePath: '',
		tcpPortMinValue: 1,
		tcpPortMaxValue: 65535,
		tcpPortError: '',
		netStatusData: {
			containerIpAddr: '',
			ftpPort: '',
			casterPort: '',
		},
		allowPppRtk: false,
	});
	Api.baseStationGetSettings(response => {
		if (response.status === 'ok') {
			formSettings.protocols = response.protocols;
			formSettings.subNetworks = response.subNetworks;
			formSettings.antReferencePoints = response.antReferencePoints;
			formSettings.supportedAntennas = response.supportedAntennas || [];
			formSettings.storagePath = response.storagePath;
			if (formState.antReferencePoint === '') {
				formState.antReferencePoint = response.antReferencePoints[0].value;
			}
			formSettings.tcpPortMinValue = response.portsRange.min;
			formSettings.tcpPortMaxValue = response.portsRange.max;
			formSettings.tcpPortError = response.portsRange.error;
			Utils.updateObject(formSettings.netStatusData, response.netStatusData);
			formSettings.allowPppRtk = response.licensePermissions.allowPppRtk;
		}
		isLoadingSettings.value = false;
	});
	return {
		isLoadingSettings,
		formSettings,
	}
}
